import $ from 'jquery';
import HelperCtrl from './helper';

const Helper = new HelperCtrl();

function CommonCtrl() {
	this.$win = $(window);
	this.headerPos = 0;

	this.anchorScroll = this.anchorScroll.bind(this);

	this.init();
}

CommonCtrl.prototype.init = function() {
	$('a[href^="#"]').on('click', this.anchorScroll);
	this.widgetSidebarToggle();
	this.blogIframe();
	this.spFixedContent();
}

// ページトップ(スマホ時だとtouchイベントだと発火が早過ぎるのでclick処理)
CommonCtrl.prototype.anchorScroll = function(e) {
	e.preventDefault();
	var hash = $(e.currentTarget).attr('href');
	if (hash === '#') return false;
	var target = $((hash == '#' ? 'html' : hash));
	var pos = target.offset();
	var header = $('header').height() + 60;
	var check = Helper.isMobile() ? 0 : header;
	var set = pos.top / 3 - 500;
	var speed = set > 500 ? set : 500;

	$('body,html').animate({
		scrollTop: pos.top - check
	}, speed, 'linear');
	$('#drawer').animate({
		scrollTop: pos.top - check
	}, speed, 'linear');
}

CommonCtrl.prototype.widgetSidebarToggle = function() {
	const $target       = $('#widget-archive > ul');
	const $tgl          = $target.find('.tgl');
	const $li_tgl       = $target.find('li:first .tgl');
	const $li_tgl_child = $target.find('li:first .tgl_child');
	$li_tgl.addClass('open');
	$li_tgl_child.show();
	$tgl.on('click', function () {
		const self = $(this);
		self.toggleClass('open');
		self.next('.tgl_child').stop().slideToggle('fast');
	});
}

CommonCtrl.prototype.blogIframe = function() {
	const $target = $('.post-body');

	$target.find('iframe').each(function () {
		const self = $(this);
		var className = 'iframe';
		var src = self.attr('src');
		var w = self.attr('width');
		var h = self.attr('height');
		if (/youtube\.com/.test(src)) {
			className += ' iframe-youtube';
		}
		self.wrap('<div class="' + className + '"></div>');
		if ($(this).parent().hasClass('iframe')) {
			var size = (h / w * 100);
			$(this).parent().css('padding-bottom', size + '%');
		}
	})
}

CommonCtrl.prototype.spFixedContent = function() {
	const $target = $('#spFixedContact');

	this.$win.on('scroll', function() {
		let pos = $(this).scrollTop();
		if (pos > this.headerPos) {
			if ($(this).scrollTop() > 0) {
				$target.addClass('scrolldown');
			}
		} else {
			$target.removeClass('scrolldown');
		}
		this.headerPos = pos;
	});
}

new CommonCtrl();